package meineglasfaser.frontend.www.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.ShopBasket
import meineglasfaser.frontend.common.components.widgets.PriceGroupView
import meineglasfaser.frontend.www.components.ShopBasketDAO
import meineglasfaser.frontend.www.components.fetchComputedBasket
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.ShopLayout")
@Composable
fun BasketPage() {
    val (_, computedBasket) = fetchComputedBasket(includeTax = true)

    Section({ classes("container") }) {
        Header {
            H1 { Text("Warenkorb") }
        }

        if (computedBasket == null || computedBasket.products.isEmpty()) {
            Article({ classes("card") }) {
                P { Text("Ihr Warenkorb ist leer.") }
            }
        } else {
            BasketView(computedBasket, showActionColumn = true)

            Footer({ classes("flex-row") }) {
                Button(attrs = {
                    classes("contrast")
                    onClick { ShopBasketDAO.clear() }
                }) { Text("Alles entfernen") }
                Div({ classes("flex-grow") }) {}
                Anchor(href = "/", {
                    role("button")
                    classes("ghost")
                }) {
                    Text("Weitershoppen")
                }
                Anchor(href = "/order", {
                    role("button")
                }) {
                    Text("Zur Kasse gehen")
                }
            }
        }
    }
}

@Composable
fun BasketView(computedBasket: ShopBasket.Computed, showActionColumn: Boolean) {
    Table({ classes("basket-table") }) {
        Thead {
            Tr {
                if (showActionColumn) Td {}
                Td { B { Text("Produkt") } }
                Td { B { Text("Menge") } }
                Td { B { Text("Preis") } }
            }
        }
        Tbody {
            computedBasket.products.forEach { entry ->
                val product = entry.product
                Tr {
                    if (showActionColumn) {
                        Td {
                            Button(attrs = {
                                onClick { ShopBasketDAO.removeProduct(product.id) }
                                classes("button", "contrast", "small")
                            }) { Text("✕") }
                        }
                    }
                    Td {
                        Div {
                            B { Text(product.title) }
                            Br()
                            Span({ classes("muted") }) { Text(product.summary.take(100)) }
                        }
                    }
                    Td {
                        Text(entry.product.quantity.toString())
                    }
                    Td {
                        PriceGroupView(product.price)
                    }
                }
                entry.addons.forEach { addon ->
                    Tr {
                        if (showActionColumn) {
                            Td {
                                Button(attrs = {
                                    onClick { ShopBasketDAO.removeProductAddon(product.id, addon.id) }
                                    classes("button", "ghost", "small")
                                }) { Text("✕") }
                            }
                        }
                        Td {
                            Div {
                                I { Text(addon.title) }
                                Br()
                                Span({ classes("muted") }) { Text(addon.summary.take(100)) }
                            }
                        }
                        Td {
                            Text(addon.quantity.toString())
                        }
                        Td {
                            PriceGroupView(addon.price * addon.quantity)
                        }
                    }
                }
            }
            Tr {
                if (showActionColumn) Td {}
                Td { B { Text("Gesamtsumme") } }
                Td {}
                Td {
                    PriceGroupView(computedBasket.totalPrice)
                }
            }
            Tr {
                if (showActionColumn) Td {}
                Td {}
                Td {}
                Td {
                    Small {
                        if (computedBasket.includesTax) {
                            Text("Alle Preise inkl. USt.")
                        } else {
                            Text("Alle Preise exkl. USt.")
                        }
                    }
                }
            }
        }
    }
}
